import ExcelJS from "exceljs";
import { useState } from "react";
import { useSelector } from "react-redux";

import {
  exportColumns,
  exportDataFormatter,
} from "../../../../utilities/exportHelpers";
import { handleAPICatch, showErrorToast } from "../../../../utilities/utils";

const ExportButton = ({
  exportFunction = null,
  isSelectedAll,
  ignoreIds,
  page,
  extraObj,
  selectedTablesData = [],
  emptyExportMessage,
  isPrimary = false,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { clientUserAllPermissions } = useSelector((state) => state.session);

  const fetchAndExportData = async () => {
    try {
      setIsLoading(true);

      // Build API request payload with the latest selection
      const postData = {
        ...extraObj,
        page,
        isSelectedAll,
        ignoreIds,
      };

      // API Call to fetch fresh data
      const res = await exportFunction(postData);

      if (res) {
        const {
          data: { export_list, isView = "" },
        } = res;

        let view = isView ? isView.toLowerCase() : "";
        let _page = isPrimary ? `primary_${page}` : page;

        // Format the export data
        const exportData = exportDataFormatter(export_list, _page);
        const exportFileName = exportData.filename;

        // Generate and download the Excel file
        await generateExcelFile(exportData.list, _page, view, exportFileName);
      } else {
        console.warn("No data returned for export");
      }
    } catch (error) {
      console.warn(error);
      handleAPICatch(error);
    } finally {
      setIsLoading(false);
    }
  };

  const generateExcelFile = async (data, page, view, filename) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Exported Data");

    const forHeader = view ? `${page}_${view}` : page;
    const columns = exportColumns[forHeader]?.map((header) => ({
      header: header.label,
      key: header.key,
    }));

    worksheet.columns = columns;
    worksheet.addRows(data);

    // Set the column width to "auto" in Excel.
    worksheet.columns.forEach((column) => {
      let maxLength = 0;
      column.eachCell?.((cell) => {
        const cellValue = cell.value ? cell.value.toString() : "";
        maxLength = Math.max(maxLength, cellValue.length);
      });
      column.width = maxLength < 10 ? 10 : maxLength + 2; // Minimum width of 10
    });

    // Generate and download the Excel file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
  };

  const handleExport = async () => {
    if (selectedTablesData.length == 0) {
      showErrorToast(emptyExportMessage, { id: "emptyExportMessage" });
      return;
    }
    await fetchAndExportData();
  };

  if (
    !clientUserAllPermissions ||
    !clientUserAllPermissions.is_allow_to_export_records
  )
    return null;

  return null;
  // return (
  //   <Tooltip title={TOOLTIPTEXT.export}>
  //     <div
  //       onClick={handleExport}
  //       className={`ExportButton_wrapper group ${ACTION_BTN_HOVER_CLR.lightBlue} ${isLoading ? "pointer-events-none cursor-not-allowed" : ""}`}
  //     >
  //       <ActionIcons isLoading={isLoading} type={"export"} />
  //     </div>
  //   </Tooltip>
  // );
};

export default ExportButton;
